import { Injectable } from '@angular/core';

import { ConfigLoader } from './config.loader';

@Injectable()
export class ConfigService {
  // eslint-disable-next-line
  protected settings: any;

  constructor(public readonly loader: ConfigLoader) {}

  // eslint-disable-next-line
  public init(): any {
    // eslint-disable-next-line
    return this.loader.loadSettings().then((res: any) => (this.settings = res));
  }

  // eslint-disable-next-line
  public getSettings<T = any>(key?: string | Array<string>, defaultValue?: any): T {
    if (!key || (Array.isArray(key) && !key[0])) {
      return this.settings;
    }

    const paths = !Array.isArray(key) ? key.split('.') : key;

    // eslint-disable-next-line
    let result = paths.reduce((acc: any, current: string) => acc && acc[current], this.settings);

    if (result === undefined) {
      result = defaultValue;

      if (result === undefined) {
        throw new Error(`No setting found with the specified key [${paths.join('/')}]!`);
      }
    }

    return result;
  }
}
